module.exports = __webpack_public_path__ + "img/91.28159ef4.jpg";